import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { UniversalLink } from '@plone/volto/components';

import ArticleIcon from './ArticleIcon';
import ArticlePager from './ArticlePager';
import BookMention from './BookMention';
import TagLinks from './TagLinks';
import useDiscoveryLinks from './useDiscoveryLinks';
import {
  formatDate,
  itemTags,
  plainTextFromBlocks,
  tagSearchPath,
} from './utils';

const fallbackExcerpt = 'この記事の読書記録です。本文で、読んだ本や親子で感じたことを紹介しています。';

const BlogDocumentView = (props) => {
  const { content } = props;
  const published = formatDate(content.effective || content.created);
  const excerpt = content.description || plainTextFromBlocks(content, 140) || fallbackExcerpt;
  const tags = itemTags(content);
  const discoveryLinks = useDiscoveryLinks();

  return (
    <Container id="page-document" className="ehon-article">
      <article>
        <div className="ehon-article-meta">
          {published && (
            <time dateTime={content.effective || content.created}>
              {published}
            </time>
          )}
          <span>読書記録</span>
          {content.creators?.[0] && <span>{content.creators[0]}</span>}
        </div>
        <TagLinks tags={tags} />

        <aside className="ehon-summary-box">
          <ArticleIcon item={content} variant="hero" />
          <div className="ehon-summary-content">
            <span className="ehon-section-label">この記事でわかること</span>
            <p>{excerpt}</p>
          </div>
        </aside>

        <RenderBlocks {...props} />

        <BookMention content={content} />

        <ArticlePager content={content} />

        <aside className="ehon-next-box">
          <span className="ehon-section-label">次に読む記事を探す</span>
          <h2>年齢やテーマで、関連する読書記録へ。</h2>
          <div className="ehon-discovery-links">
            {discoveryLinks.slice(0, 6).map((link) => (
              <UniversalLink
                href={tagSearchPath(link.tag)}
                key={link.label}
              >
                #{link.label}
              </UniversalLink>
            ))}
          </div>
          <p className="ehon-contact-note">
            感想やおすすめの絵本があれば、
            <UniversalLink href="/contact">お問い合わせフォーム</UniversalLink>
            からお知らせください。
          </p>
        </aside>
      </article>
    </Container>
  );
};

BlogDocumentView.propTypes = {
  content: PropTypes.shape({
    created: PropTypes.string,
    creators: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.string,
    effective: PropTypes.string,
    image_field: PropTypes.string,
    Subject: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default BlogDocumentView;
